module.exports = __webpack_public_path__ + "static/img/546.7fa91c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/546.png
// module id = 394
// module chunks = 12 14